import React, { useContext, useMemo, useCallback } from 'react';
import MemoTag from 'memos/MemoTag'
import ColorConstants from 'constants/ColorConstants'
import ExcerptConstants from 'constants/ExcerptConstants'
import ExcerptTitle from 'excerpts/ExcerptTitle';
import CodeMultiSelect from './CodeSelector/CodeMultiSelect';
import ExcerptCodesList from './ExcerptCodesList';

import ProjectContext from 'contexts/ProjectContext';


function ExcerptBody(props) {
  const {
    excerpt = {},
    selected,
    hover,
    onTextClicked,
    onLinkClick,
    onCodeRemove,
    codePage,
    hasEditPermission,
    onCodeClick,
    disabled,
    onMouseLeave,
    onMouseEnter,
    expandMemos,
    memoCount,
    showMemoIndicator,
  } = props;

  const projectContext = useContext(ProjectContext);
  const projectID = projectContext?.project?.id

  const handleLinkClick = useCallback((e) => {
    if (onLinkClick) onLinkClick(excerpt.id);
  }, [onLinkClick, excerpt.id]);

  const handleClick = useCallback((e) => {
    onTextClicked && onTextClicked(excerpt.id);
    if (!e) e = window.event;
    if (e.stopPropagation) e.stopPropagation();
    else e.cancelBubble = true;
  }, [onTextClicked, excerpt.id]);

  let style = {};
  if (selected)
    style = { backgroundColor: ColorConstants.HIGHLIGHT_COLOR };
  else if (hover)
    style = { backgroundColor: ColorConstants.HOVER_COLOR };

  const excerptText = excerpt.text ? excerpt.text : "";
  const text = excerptText.split('\n').map((paragraph, index) =>
    <p key={index}><span style={style}>{paragraph}</span></p>
  );

  const textDiv = disabled || !hasEditPermission ?
    <div style={{ cursor: "default" }}> {text} </div> :
    <div
      style={{ cursor: "pointer" }}
      onMouseLeave={onMouseLeave}
      onMouseEnter={onMouseEnter}
      onClick={handleClick}
    > {text} </div>;

  // Extract code IDs for the CodeMultiSelect component
  const excerptCodeIds = useMemo(() => {
    return (excerpt.codings || []).map(coding => coding.code_id);
  }, [excerpt.codings?.map(coding => coding.code_id).join(',')]);

  return (
    <div style={{
      marginTop: ExcerptConstants.PADDING,
      marginBottom: '20px',
      marginLeft: ExcerptConstants.PADDING,
      marginRight: ExcerptConstants.PADDING,
    }}>
      <ExcerptTitle excerpt={excerpt} onLinkClick={handleLinkClick} />

      {textDiv}

      <div style={{ wordWrap: 'break-word', display: "flex" }}>
        <div style={{ flexGrow: 1, maxWidth: '90%' }}>
          {hasEditPermission && (
            <CodeMultiSelect
              projectID={projectID}
              excerptCodeIds={excerptCodeIds}
              excerptId={excerpt?.id}
            />
          )}
          <ExcerptCodesList
            codings={excerpt.codings || []}
            excerptId={excerpt.id}
            codePage={codePage}
            selected={selected}
            hasEditPermission={hasEditPermission}
            onCodeRemove={onCodeRemove}
            onCodeClick={onCodeClick}
            projectID={projectID}
          />
        </div>

        <div style={{ marginTop: "3px", marginLeft: 'auto' }}>
          <MemoTag
            onClick={expandMemos}
            count={memoCount}
            show={showMemoIndicator}
            selected={selected}
          />
        </div>
      </div>
    </div>
  );
}

export default ExcerptBody;
